import React, { useState, useEffect, useRef, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { Calendar } from "primereact/calendar";
import { InputTextarea } from "primereact/inputtextarea";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { AuthContext } from "../../../Header/auth - context.js";
import { Button } from "primereact/button";
import { useSelector } from "react-redux";
import CustomDropdown from "../../../custom/customDropdown.js";
import { Card } from 'primereact/card';
import { MultiSelect } from 'primereact/multiselect';
import { confirmDialog } from 'primereact/confirmdialog';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { InputText } from 'primereact/inputtext';

import "./unosradnihpopup.css";

const UnosRadnihPop = (props) => {
  const { t } = useTranslation();

  const toast = useRef(null);
  const auth = useContext(AuthContext);
  const company = useSelector((state) => state.company);
  const user = useSelector(state => state.user);
  const location = useLocation();
  const formRef = useRef(null);
  const formRefItems = useRef(null);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formSubmittedItems, setFormSubmittedItems] = useState(false);
  const [logRNToUpdate, setlogRNToUpdate] = useState(null);
  const [serviceLogNumber, setServiceLogNumber] = useState([]);
  const [stavkaRN, setStavkaRN] = useState([]);
  const [idServiceLog, setIdServiceLog] = useState(null);
  const [nalog, setNalog] = useState(null)
  const [izabran, setIzabran] = useState(false)
  const [servisniNaloziDB, setServisniNaloziDB] = useState([])
  const [tipoviOdrzavanjaDB, setTipoviOdrzavanjaDB] = useState([])
  const [podTipoviOdrzavanjaDB, setPodTipoviOdrzavanjaDB] = useState([])
  const [magacinDB, setMagacinDB] = useState([])
  const [KlijentiDB, setKlijentiDB] = useState([])
  const [statusServisaDB, setStatusServisaDB] = useState([])
  const [tipServisaDB, setTipServisaDB] = useState([])
  const [porukaTimeRange, setPorukeTimeRange] = useState(null)
  const [porukaSameRepairMan, setPorukaSameRepairMan] = useState(null)
  const [porukaKolicina, setPorukaKolicina] = useState(null)
  const [popuni, setPopuni] = useState(null)

  const [valueTASL, setValueTASL] = useState("");
  const [vehicleDB, setVehicleDB] = useState([]);
  const [partDB, setPartDB] = useState([]);
  const [gumeDB, setGumeDB] = useState([]);
  const [employeeDB, setEmployeeDB] = useState([]);
  const [employeeDriverDB, setEmployeeDriverDB] = useState([]);



   const [formDataServiceLog, setFormDataServiceLog] = useState({
        tip_servisa: null,
        id_vozilo: null,
        id_klijent: null,
        registracija_klijenta: '',
        id_faktura: null,
        tip_odrzavanja: [],
        pod_tip_odrzavanja: [],
        id_zaposleni_prijavio: null,
        id_zaposleni_majstor: null,
        ostaliMajstori: [],
        datumPocetka: null,
        spisakRadova: [],
        statusServisa: null,
        datumZavrsetka: null,
        kilometraza: null,
        napomena: '',
        napomenaVozaca: ''
    });

  const [formDataServiceLogItems, setFormDataServiceLogItems] = useState({
    id_magacin: null,
    id_deo: null,
    kolicina: null,
    isGuma: false,
    ser_broj: null
  })
  const [formDataServiceLogItemsData, setFormDataServiceLogItemsData] = useState([])

  const [render, setRender] = useState(false);


  const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

  const handleConfirmDeleteLogDialog = () => {
    confirmDialog({
      message: "Jel ste sigurni da želite obrisati radni nalog?",
      acceptLabel: "Da",
      rejectLabel: "Ne",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      accept: acceptDelete,
      reject: rejectDelete,
    });
  };

  const acceptDelete = async () => {
                if(izabran){
                              let requestOptions = {
                                method: "DELETE",
                                headers: {
                                "Content-Type": "application/json",
                                Authorization: "Bearer " + auth.token,
                                },
                                body: JSON.stringify({
                                    id: idServiceLog
                                }),
                            };
                            await fetch(process.env.REACT_APP_BACKEND_URL + "/service/DeleteServiceLog", requestOptions)
                                .then(handleErrors)
                                .then((data) => {
                                  if(data){
                                    if(data.message != "Uspešno pasiviziranje servisnog naloga!"){
                                      toast.current.show({ severity: "error", summary: "Error", detail: data.message, life: 3000 });
                                      return
                                    }
                                  }
                                  setIdServiceLog(null)
                                  setIzabran(null)
                                  setPopuni(null)
                                  toast.current.show({ severity: "success", summary: data.message, life: 3000 });
                                })
                                .catch((error) => {
                                  error.json().then((errorMessage) => {
                                    toast.current.show({ severity: "error", summary: "Error", detail: errorMessage.message, life: 3000 });
                                    console.log(errorMessage);
                                  });
                                });
                } else {
                  toast.current.show({ severity: "warn", summary: "Upozorenje!", detail: "Nije moguće obrisati servisni nalog, nije izabran!", life: 3000 });
                }
  };

  const rejectDelete = () => {
    console.log("Odbijeno brisanje servisnog naloga!");
  };

  useEffect(() => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      }
    };

    fetch(process.env.REACT_APP_BACKEND_URL + "/service", requestOptions)
      .then(handleErrors)
      .then((data) => {
            const stringifiedJson = data[0][""];
            const parsedData = JSON.parse(stringifiedJson);
            setServisniNaloziDB(parsedData.ServisniNaloziDB)
            setTipoviOdrzavanjaDB(parsedData.TipoviOdrzavanjaDB)
            setPodTipoviOdrzavanjaDB(parsedData.PodTipoviOdrzavanjaDB)
            setMagacinDB(parsedData.MagacinDB)
            setKlijentiDB(parsedData.KlijentiDB)
            setStatusServisaDB(parsedData.StatusiDB)
            setVehicleDB(parsedData.VehicleDB)
            setPartDB(parsedData.PartDB)
            setEmployeeDB(parsedData.EmployeeDB)
            setEmployeeDriverDB(parsedData.EmployeeDriverDB)
            setTipServisaDB(parsedData.TipServisaDB || [])
            setGumeDB(parsedData.GumeDB || [])
      })
      .catch((error) => {
        error.json().then((errorMessage) => {
          toast.current.show({ severity: "error", summary: "Error", detail: errorMessage.message, life: 3000 });
          console.log(errorMessage);
        });
      });
  }, [formSubmitted]);

  useEffect(() => {
    const stateId = location.state?.selectedServiceLogId;
    if (stateId) {
      setIdServiceLog(stateId);
      setIzabran(true);
      setPopuni(true);
      fillServiceData(stateId);
    }
  }, []);

  const resetData = () => {
    setFormDataServiceLog({
        tip_servisa: null,
        id_vozilo: null,
        id_klijent: null,
        registracija_klijenta: '',
        id_faktura: null,
        tip_odrzavanja: [],
        pod_tip_odrzavanja: [],
        id_zaposleni_prijavio: null,
        id_zaposleni_majstor: null,
        ostaliMajstori: [],
        datumPocetka: null,
        spisakRadova: [],
        statusServisa: null,
        datumZavrsetka: null,
        kilometraza: null,
        napomena: '',
        napomenaVozaca: ''
    });
    setFormDataServiceLogItems({ id_magacin: null, id_deo: null, kolicina: null, isGuma: false, ser_broj: null })
    setFormDataServiceLogItemsData([])
    if (render === true) {
      setRender(false);
    } else {
      setRender(true);
    }
  }

  const selectIdServiceLogFUNC = (e) => {
    const val = e.target.value;
    if (val == undefined) {
      setIzabran(false);
      setPopuni(false);
      resetData();
    } else {
      setIzabran(true);
      setPopuni(true);
      fillServiceData(val);
    }
    setIdServiceLog(val);
  };

  const handleClickServiceLog = () => {
    if (idServiceLog) {
      setIdServiceLog(null);
      setIzabran(false);
      setPopuni(false);
      resetData();
    }
  }

  const parseArrayField = (value) => {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    try {
      return JSON.parse(value);
    } catch {
      const trimmed = String(value).trim();
      if (trimmed.startsWith("[") && trimmed.endsWith("]")) {
        const inner = trimmed.slice(1, -1).trim();
        if (!inner) return [];
        return inner.split(",").map(x => x.trim()).filter(Boolean);
      }
      return [];
    }
  };

  const popuniStavke = (apiData) => {
    const data = apiData[0].ServiceDBFill;
    const data2 = apiData[1]

    setFormDataServiceLog({
        tip_servisa: data.tip_servisa || null,
        id_vozilo: data.id_vozilo || null,
        id_klijent: data.id_klijent || null,
        registracija_klijenta: data.registracija_klijenta || '',
        id_faktura: data.id_faktura || null,
        tip_odrzavanja: data.tip_odrzavanja || [],
        pod_tip_odrzavanja: data.pod_tip_odrzavanja || [],
        id_zaposleni_prijavio: data.id_zaposleni_prijavio || null,
        id_zaposleni_majstor: data.id_zaposleni_majstor || null,
        ostaliMajstori: data.ostaliMajstori ? JSON.parse(data.ostaliMajstori) : [],
        datumPocetka: data.datumPocetka ? new Date(data.datumPocetka) : null,
        spisakRadova: parseArrayField(data.spisakRadova),
        statusServisa: data.statusServisa || null,
        datumZavrsetka: data.datumZavrsetka ? new Date(data.datumZavrsetka) : null,
        kilometraza: data.kilometraza || null,
        napomena: data.napomena || '',
        napomenaVozaca: data.napomenaVozaca || ''
    });

    if(data2.StavkeServisa) {
      const itemsData = data2.StavkeServisa.map(stavka => ({
        ID: stavka.ID || null,
        id_magacin: stavka.id_magacin || null,
        id_deo: stavka.id_deo || null,
        kolicina: stavka.kolicina || null,
        isGuma: !!stavka.isGuma,
        ser_broj: stavka.SerBroj || null,
        naziv_artikla: stavka.NazivArtikla || null
      }));
      setFormDataServiceLogItemsData(itemsData);
    }

  };

  const fillServiceData = async (id) => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      },
      body: JSON.stringify({ id }),
    };
    await fetch(process.env.REACT_APP_BACKEND_URL + "/service/FillInServiceData", requestOptions)
      .then(handleErrors)
      .then((data) => {
        if (data.message) {
          toast.current.show({ severity: "error", summary: "Error", detail: data.message, life: 3000 });
          return;
        }
        popuniStavke(data);
        toast.current.show({ severity: "success", summary: "Uspešno popunjavanje podataka servisnog naloga!", life: 3000 });
      })
      .catch((error) => {
        error.json().then((errorMessage) => {
          toast.current.show({ severity: "error", summary: "Error", detail: errorMessage.message, life: 3000 });
          console.log(errorMessage);
        });
      });
  };

  const popuniRedove = async () => {
    if (!idServiceLog) {
      toast.current.show({ severity: "warn", summary: "Upozorenje!", detail: "Niste izabrali servisni nalog da bi popunili podatke!", life: 3000 });
      return;
    }
    setPopuni(true);
    await fillServiceData(idServiceLog);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setFormSubmitted(true)
    if (formRef.current && !formRef.current.checkValidity()) {
      formRef.current.reportValidity();
      return;
    }
    const selectedStatus = statusServisaDB.find(s => s.value === formDataServiceLog.statusServisa);
    if (selectedStatus?.label === 'Završen' && !formDataServiceLog.datumZavrsetka) {
      toast.current.show({ severity: 'warn', summary: 'Datum završetka je obavezan za status Završen!', life: 4000 });
      return;
    }
    handleUploadAndSave()
  }

  const handleUploadAndSave = () => {
    confirmDialog({
      message: "Jel ste sigurni da želite nastaviti sa unosom?",
      acceptLabel: "Da",
      rejectLabel: "Ne",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: acceptInsert,
      reject: rejectInsert,
    });
  };

  function toUtcIso(d) {
    if (!d) return null;
    const x = d instanceof Date ? d : new Date(d);
    const utc = new Date(x.getTime() - x.getTimezoneOffset() * 60000);
    return utc.toISOString().slice(0, 19) + 'Z';
  }

  const acceptInsert = async () => {
    const hasAnyValueServiceLog = Object.values(formDataServiceLog).some(value => {
      if (value === null || value === '') return false;
      if (value instanceof Date && isNaN(value.getTime())) return false;
      return true;
    });

    const payload = {
      ...formDataServiceLog,
      datumPocetka: toUtcIso(formDataServiceLog.datumPocetka),
      datumZavrsetka: toUtcIso(formDataServiceLog.datumZavrsetka),
    };

    if(izabran && popuni && idServiceLog){
      if(hasAnyValueServiceLog){
        let requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: "Bearer " + auth.token },
          body: JSON.stringify({
            id: idServiceLog,
            formDataServiceLog: payload,
            stavke: formDataServiceLogItemsData.map(({ ser_broj, ...rest }) => ({ ...rest, SerBroj: ser_broj })),
          }),
        };
        await fetch(process.env.REACT_APP_BACKEND_URL + "/service/UpdateServiceLog", requestOptions)
          .then(handleErrors)
          .then((data) => {
            if(data){
              if(data[0].message == 'Nema izmena u podacima servisnog naloga.'){
                toast.current.show({ severity: "warn", summary: data[0].message, life: 3000 });
              } else {
                toast.current.show({ severity: "success", summary: "Uspešna izmena podataka servisnog naloga!", life: 3000 });
              }
              setFormSubmitted(false)
            }
          })
          .catch((error) => {
            error.json().then((errorMessage) => {
              toast.current.show({ severity: "error", summary: "Error", detail: errorMessage.message, life: 3000 });
              console.log(errorMessage);
            });
          });
      } else {
        toast.current.show({ severity: "warn", summary: "Upozorenje!", detail: "Niste popunili podatke servisnog naloga za unos!", life: 3000 });
      }
    } else {
      if(hasAnyValueServiceLog){
        let requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: "Bearer " + auth.token },
          body: JSON.stringify({
            formDataServiceLog: payload,
            stavke: formDataServiceLogItemsData.map(({ ser_broj, ...rest }) => ({ ...rest, SerBroj: ser_broj })),
          }),
        };
        await fetch(process.env.REACT_APP_BACKEND_URL + "/service/InsertServiceLog", requestOptions)
          .then(handleErrors)
          .then((data) => {
            if(data.message){
              toast.current.show({ severity: "error", summary: "Error", detail: data.message, life: 3000 });
              return
            }
            setFormSubmitted(false)
            resetData()
            setIzabran(false)
            toast.current.show({ severity: "success", summary: "Uspešan unos servisnog naloga!", life: 3000 });
          })
          .catch((error) => {
            error.json().then((errorMessage) => {
              toast.current.show({ severity: "error", summary: "Error", detail: errorMessage.message, life: 3000 });
              console.log(errorMessage);
            });
          });
      } else {
        toast.current.show({ severity: "warn", summary: "Upozorenje!", detail: "Niste popunili podatke servisnog naloga za unos!", life: 3000 });
      }
    }
  };

  const rejectInsert = () => {
    console.log("Odbijen unos podataka!");
  };

  const handleInputItems = (e) => {
    e.preventDefault();
    setFormSubmittedItems(true);
    if (formRefItems.current && !formRefItems.current.checkValidity()) {
      formRefItems.current.reportValidity();
      return;
    }
    if (formDataServiceLogItems.id_deo !== null && formDataServiceLogItems.kolicina !== null) {
      const deo = partDB.find(p => p.value == formDataServiceLogItems.id_deo);
      if (deo && deo.kolicina !== undefined && deo.kolicina !== null) {
        const unetaKolicina = parseFloat(formDataServiceLogItems.kolicina);
        const dostupnaKolicina = parseFloat(deo.kolicina);
        if (!isNaN(unetaKolicina) && !isNaN(dostupnaKolicina)) {
          const ukupnaKolicinaIzStavki = formDataServiceLogItemsData
            .filter(item => item.id_deo === formDataServiceLogItems.id_deo && item.kolicina !== null)
            .reduce((sum, item) => sum + parseFloat(item.kolicina), 0);
          const novaUkupnaKolicina = ukupnaKolicinaIzStavki + unetaKolicina;
          if (unetaKolicina <= 0) {
            setPorukaKolicina('Količina mora biti veća od 0!');
            return;
          } else if (unetaKolicina > dostupnaKolicina) {
            setPorukaKolicina(`Pojedinačna količina ne može biti veća od ${dostupnaKolicina}!`);
            return;
          } else if (novaUkupnaKolicina > dostupnaKolicina) {
            setPorukaKolicina(`Ukupna količina (${novaUkupnaKolicina}) premašuje dostupnu (${dostupnaKolicina})!`);
            return;
          }
        }
      }
    }
    setFormDataServiceLogItemsData([
      ...formDataServiceLogItemsData,
      {
        id_magacin: formDataServiceLogItems.id_magacin,
        id_deo: formDataServiceLogItems.id_deo,
        kolicina: formDataServiceLogItems.kolicina,
        isGuma: formDataServiceLogItems.isGuma,
        ser_broj: formDataServiceLogItems.ser_broj
      }
    ]);
    if (porukaKolicina != null) { setPorukaKolicina(null); }
  };

  const invalidControl = (data) => {
    if (!formSubmitted) return false;
    if (data && data != null && !Number(data)) {
      return data.length > 0 ? false : true;
    } else if (data != null && Number(data)) {
      return false;
    }
    return true;
  };

  const invalidControlItems = (data) => {
    if (!formSubmittedItems) return false;
    if (data && data != null && !Number(data)) {
      return data.length > 0 ? false : true;
    } else if (data != null && Number(data)) {
      return false;
    }
    return true;
  };


  const handleChange = (e, index) => {
    const { name, value } = e.target || e;
    if (name === "ostaliMajstori") {
      let same = false;
      for(let i=0; i< formDataServiceLog.ostaliMajstori.length; i++){
        if (formDataServiceLog.ostaliMajstori[i] === value || formDataServiceLog.id_zaposleni_majstor === value) {
          same = true;
          break
        }
      }
      if (same) {
        setFormDataServiceLog(prev => {
          const updated = [...prev.ostaliMajstori];
          updated[index] = null;
          return { ...prev, ostaliMajstori: updated };
        });
        setPorukaSameRepairMan('Ne možeš izabrati istog majstora!');
        return;
      } else {
        if (porukaSameRepairMan != null) { setPorukaSameRepairMan(null); }
        setFormDataServiceLog(prev => {
          const updated = [...prev.ostaliMajstori];
          updated[index] = value;
          return { ...prev, ostaliMajstori: updated };
        });
      }
    } else if (name === "spisakRadova") {
      console.log(value)
      setFormDataServiceLog(prev => {
        const updated = [...prev.spisakRadova];
        updated[index] = value;
        return { ...prev, spisakRadova: updated };
      });
    } else if (name in formDataServiceLog) {
      if (name === 'tip_odrzavanja') {
        const trenutniPodTipovi = formDataServiceLog.pod_tip_odrzavanja || [];
        if (trenutniPodTipovi.length > 0) {
          const validniPodTipovi = trenutniPodTipovi.filter(podTipId => {
            const podTip = podTipoviOdrzavanjaDB.find(pt => pt.value === podTipId);
            return podTip && value.includes(podTip.id_tip_odrzavanja);
          });
          if (validniPodTipovi.length !== trenutniPodTipovi.length) {
            setFormDataServiceLog(prev => ({ ...prev, [name]: value, pod_tip_odrzavanja: validniPodTipovi }));
            return;
          }
        }
      }
      if(name == 'datumZavrsetka'){
        const datumPocetka = new Date(formDataServiceLog.datumPocetka);
        const datumZavrsetka = new Date(value);
        if (datumPocetka >= datumZavrsetka) {
          setFormDataServiceLog(prev => ({ ...prev, datumZavrsetka: '' }));
          setPorukeTimeRange('Datum završetka ne može biti pre datuma početka!');
          return;
        } else {
          if (porukaTimeRange != null) { setPorukeTimeRange(null); }
        }
      }
      setFormDataServiceLog(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleChangeItems = (e) => {
    const { name, value } = e.target;
    if (name === 'isGuma') {
      setFormDataServiceLogItems({ id_magacin: null, id_deo: null, kolicina: null, isGuma: value, ser_broj: null });
      return;
    }
    if (name === 'ser_broj') {
      setFormDataServiceLogItems(prev => ({ ...prev, ser_broj: value }));
      return;
    }
    if (name in formDataServiceLogItems) {
      if(name == 'id_deo'){
        if(value) {
          if (formDataServiceLogItems.isGuma) {
            setFormDataServiceLogItems(prev => ({ ...prev, kolicina: 1, ser_broj: null }));
          } else {
            let kol = partDB.filter(p => p.value == value);
            setFormDataServiceLogItems(prev => ({ ...prev, kolicina: kol[0]?.kolicina ?? null }));
          }
        } else {
          if(formDataServiceLogItems.kolicina != null)
            setFormDataServiceLogItems(prev => ({ ...prev, ['kolicina']: null }))
        }
      }
      if(name == 'id_magacin') {
        setFormDataServiceLogItems(prev => ({ ...prev, id_deo: null, kolicina: null, ser_broj: null }))
      }
      if(name == 'kolicina' && formDataServiceLogItems.id_deo !== null && !formDataServiceLogItems.isGuma) {
        const deo = partDB.find(p => p.value == formDataServiceLogItems.id_deo);
        if (deo && deo.kolicina !== undefined && deo.kolicina !== null) {
          const unetaKolicina = parseFloat(value);
          const dostupnaKolicina = parseFloat(deo.kolicina);
          if (!isNaN(unetaKolicina) && !isNaN(dostupnaKolicina)) {
            if (unetaKolicina > dostupnaKolicina) {
              setFormDataServiceLogItems(prev => ({ ...prev, [name]: null }));
              const kolicinaInput = document.querySelector('input[name="kolicina"]')
              kolicinaInput.value = '';
              setPorukaKolicina(`Količina ne može biti veća od ${dostupnaKolicina}!`);
              return;
            } else if (unetaKolicina <= 0) {
              setFormDataServiceLogItems(prev => ({ ...prev, [name]: null }));
              setPorukaKolicina('Količina mora biti veća od 0!');
              return;
            }
          }
        }
        if (porukaKolicina != null) { setPorukaKolicina(null); }
      }
      setFormDataServiceLogItems(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleDeleteItem = (index) => {
    const newItems = formDataServiceLogItemsData.filter((_, i) => i !== index);
    setFormDataServiceLogItemsData(newItems);
  };

  const addRepairman = () => {
    if(formDataServiceLog.ostaliMajstori.length < 3){
      setFormDataServiceLog(prev => ({
        ...prev,
        ostaliMajstori: [...prev.ostaliMajstori, null]
      }));
    }
  };

  const addRepair = () => {
    setFormDataServiceLog(prev => ({
      ...prev,
      spisakRadova: [...prev.spisakRadova, '']
    }));
  };

  const removeRepairman = (index) => {
    setFormDataServiceLog(prev => ({
      ...prev,
      ostaliMajstori: prev.ostaliMajstori.filter((_, i) => i !== index)
    }));
  };

  const removeRepair = (index) => {
    setFormDataServiceLog(prev => ({
      ...prev,
      spisakRadova: prev.spisakRadova.filter((_, i) => i !== index)
    }));
  };

  const handleUveziFakturu = () => {
    // TODO: implementirati vezu fakture za Eksterno
  };

  const handleIzdajFakturu = () => {
    // TODO: implementirati izdavanje fakture za Usluzno
  };

  const isZavrsen = !!(
    izabran &&
    popuni &&
    formDataServiceLog.statusServisa &&
    statusServisaDB.find(s => s.value === formDataServiceLog.statusServisa)?.label === 'Završen'
  );

  return (
    <>
      <div className="col-12" style={{display:'flex',alignItems: "center", width: '100%'}}>

                                    <div style={{width: '60%', margin: '2% 0'}}>
                                           {(idServiceLog &&  !popuni) && <p class="infoPoruka">Servisni nalog je seletovan.</p>}

                                        <div style={{display:'flex',alignItems: "center"}}>
                                            <h4>{t('servis.izborServisnog')}:</h4>

                                            <CustomDropdown
                                               style={{ width: "30.65%", margin: "0 0 0 2%" }}
                                                options={servisniNaloziDB || []}
                                                value={idServiceLog}
                                                placeholder={t('ture.brojRadnogNaloga')}
                                                optionLabel="label"
                                                onChange={selectIdServiceLogFUNC}
                                                onFocus={handleClickServiceLog} />

                                    {izabran && !isZavrsen && <Button label={t('common.delete')} className="mt-3 zaposleniShift" onClick={handleConfirmDeleteLogDialog} style={{width: 'fit-content'}}/>}
                                    {isZavrsen && (
                                      <div style={{ margin: '1%', minWidth:'fit-content', padding: '0.6rem 1rem', background: '#fff3e0', border: '1px solid #ffa000', borderRadius: 6, display: 'flex', alignItems: 'center', gap: '0.5rem', color: '#e65100', fontWeight: 500 }}>
                                        <i className="pi pi-lock" />
                                        Servisni nalog je završen — izmene nisu dozvoljene.
                                      </div>
                                    )}
                                        </div>

                                    </div>

                            </div>



   <div id="unos_d" style={isZavrsen ? { pointerEvents: 'none', opacity: 0.75 } : {}}>

    <Toast ref={toast} />
    <ConfirmDialog />
      <form autoComplete="off" ref={formRef}>
        <div className="col-12 md:col-6">

                            <Card className="servisGrupa" style={{ marginBottom: '1rem' }}>
                              {(() => {
                                const tipLabel = tipServisaDB.find(t => t.value === formDataServiceLog.tip_servisa)?.label || '';
                                const isInterno  = tipLabel === 'Interno';
                                const isEksterno = tipLabel === 'Eksterno';
                                const isUsluzno  = tipLabel === 'Usluzno';
                                return (
                                  <div className="gridLicni">
                                    <div className="col-12 md:col-6">
                                      <label>{t('servis.tipServisa')}:</label>
                                      <Dropdown
                                        name="tip_servisa"
                                        value={formDataServiceLog.tip_servisa}
                                        options={tipServisaDB}
                                        required
                                        invalid={invalidControl(formDataServiceLog.tip_servisa)}
                                        placeholder={t('servis.tipServisa')}
                                        style={{ width: '100%' }}
                                        onChange={handleChange}
                                      />
                                    </div>

                                    <div className="col-12 md:col-6">
                                      <label>{t('servis.regSopstveno')}:</label>
                                      <CustomDropdown
                                        name="id_vozilo"
                                        value={formDataServiceLog.id_vozilo}
                                        options={vehicleDB || []}
                                        required={!isUsluzno}
                                        invalid={!isUsluzno && invalidControl(formDataServiceLog.id_vozilo)}
                                        disabled={isUsluzno}
                                        placeholder={t('ture.registracija')}
                                        optionLabel="label"
                                        style={{ width: '100%' }}
                                        onChange={handleChange}
                                      />
                                    </div>

                                    <div className="col-12 md:col-6">
                                      <label>{t('nova.klijent')}:</label>
                                      <CustomDropdown
                                        name="id_klijent"
                                        value={formDataServiceLog.id_klijent}
                                        options={KlijentiDB || []}
                                        required={isEksterno || isUsluzno}
                                        invalid={(isEksterno || isUsluzno) && invalidControl(formDataServiceLog.id_klijent)}
                                        disabled={isInterno || !formDataServiceLog.tip_servisa}
                                        placeholder={t('nova.klijent')}
                                        optionLabel="label"
                                        style={{ width: '100%' }}
                                        onChange={handleChange}
                                      />
                                    </div>

                                    <div className="col-12 md:col-6">
                                      <label>{t('servis.regKlijentaVozila')}:</label>
                                      <InputText
                                        name="registracija_klijenta"
                                        value={formDataServiceLog.registracija_klijenta}
                                        required={isUsluzno}
                                        invalid={isUsluzno && invalidControl(formDataServiceLog.registracija_klijenta)}
                                        disabled={!isUsluzno}
                                        placeholder={t('servis.regKlijenta')}
                                        style={{ width: '100%' }}
                                        onChange={handleChange}
                                      />
                                    </div>

                                    <div className="col-12 md:col-6">
                                      <label>{t('ture.kilometraza')}:</label>
                                      <InputNumber
                                        name="kilometraza"
                                        value={formDataServiceLog.kilometraza}
                                        required
                                        invalid={invalidControl(formDataServiceLog.kilometraza)}
                                        suffix=" [km]"
                                        style={{ width: '100%' }}
                                        onValueChange={handleChange}
                                      />
                                    </div>

                                    {(isEksterno || isUsluzno) && (
                                      <div className="col-12" style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap', marginTop: '0.5rem' }}>
                                        {isEksterno && (
                                          <Button
                                            label={t('servis.fakturisi')}
                                            className="p-button-success"
                                            type="button"
                                            onClick={handleUveziFakturu}
                                          />
                                        )}
                                        {isUsluzno && (
                                          <Button
                                            label={t('servis.fakturisi')}
                                            className="p-button-success"
                                            type="button"
                                            disabled={!idServiceLog}
                                            onClick={handleIzdajFakturu}
                                          />
                                        )}
                                        {formDataServiceLog.id_faktura ? (
                                          <span style={{ color: '#2e7d32', fontWeight: 600 }}>
                                            <i className="pi pi-check-circle" style={{ marginRight: '0.3rem' }} />
                                            Faktura #{formDataServiceLog.id_faktura} je povezana
                                          </span>
                                        ) : (
                                          <span className="infoPoruka">Faktura nije povezana</span>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                );
                              })()}
                            </Card>
                            <Card>
                                <div className="gridLicni" style={{marginBottom: '1%'}}>
                                       <div className="col-12 md:col-6">
                                            <label htmlFor="PregledOpreme">{t('servis.tipOdrzavanja')}:</label>
                                            <MultiSelect
                                                    id="tip_odrzavanja"
                                                    name="tip_odrzavanja"
                                                    style={{width:"100%"}}
                                                    value={formDataServiceLog.tip_odrzavanja}
                                                    options={tipoviOdrzavanjaDB}
                                                    optionLabel="label"
                                                    optionValue="value"
                                                    placeholder={t('servis.phTipOdrzavanja')}
                                                    display="chip"
                                                    filter
                                                    showSelectAll={true}
                                                    onChange={handleChange}
                                                />
                                        </div>
                                    <div className="col-12 md:col-6">
                                            <label htmlFor="PregledOpreme">{t('servis.vrstaOdrzavanja')}:</label>
                                            <MultiSelect
                                                      style={{width:"100%"}}
                                                      id="pod_tip_odrzavanja"
                                                      name="pod_tip_odrzavanja"
                                                      value={formDataServiceLog.pod_tip_odrzavanja}
                                                      options={
                                                        podTipoviOdrzavanjaDB.filter(pt =>
                                                          formDataServiceLog.tip_odrzavanja.includes(pt.id_tip_odrzavanja))
                                                        }
                                                      optionLabel="label"
                                                      optionValue="value"
                                                      placeholder={t('servis.phVrstuOdrzavanja')}
                                                      display="chip"
                                                      filter
                                                      showSelectAll={true}
                                                      onChange={handleChange}
                                                  />
                                        </div>
                                    <div className="col-12 md:col-6">
                                        <label htmlFor="id_zaposleni_prijavio">{t('servis.zaposleniPrijavio')}:</label>
                                              <CustomDropdown
                                                      id="id_zaposleni_prijavio"
                                                      name="id_zaposleni_prijavio"
                                                      value={formDataServiceLog.id_zaposleni_prijavio}
                                                      onChange={handleChange}
                                                      style={{width:"100%"}}
                                                      className=""
                                                      optionLabel="label"
                                                      options={employeeDriverDB || []}
                                                      placeholder={t('servis.zaposleniPrijavio')}
                                                      required
                                                      invalid={invalidControl(formDataServiceLog.id_zaposleni_prijavio)}
                                                    />
                                    </div>
                                    <div className="col-12 md:col-6">
                                        <label htmlFor="id_zaposleni_majstor">{t('servis.odgovorniMajstor')}:</label>
                                        <CustomDropdown
                                                      id="id_zaposleni_majstor"
                                                      name="id_zaposleni_majstor"
                                                      value={formDataServiceLog.id_zaposleni_majstor}
                                                      onChange={handleChange}
                                                      style={{width:"100%"}}
                                                      className=""
                                                      optionLabel="label"
                                                      options={employeeDB || []}
                                                      placeholder={t('servis.odgovorniMajstor')}
                                                    />
                                    </div>
                                     <div className="col-12 md:col-6">
                                                                                         <div style={{display:'flex', justifyContent: 'space-between'}}>
                                                                                             <h5 style={{ width: '85%', marginTop: '2%' }}>{t('servis.dodatniMajstor')}:</h5>
                                                                                             <div style={{ marginTop: "0", width: "15%", padding: '1% 0 1% 0', scale: '0.7' }}>
                                                                                                 <Button icon="pi pi-plus" type="button" onClick={addRepairman} className="p-button-success" />
                                                                                             </div>
                                                                                         </div>
                                                                             <div className="additionalRepairman">
                                                                              {porukaSameRepairMan && <p class="infoPoruka" style={{fontSize: "10px"}}>{porukaSameRepairMan}</p>}
                                                                                 {formDataServiceLog.ostaliMajstori.map((majstor, index) => (
                                                                                     <div key={index} className="red1 odgovornaLica">
                                                                                         <div className="col-12 md:col-6">
                                                                                             <div style={{display:'flex', justifyContent: 'space-between', width:'100%'}}>
                                                                                                 <div style={{ flex: '0 0 85%', marginTop: '2%', marginLeft: '2%' }}>
                                                                                                     <label >Majstor  {index + 1}:</label>
                                                                                                 </div>
                                                                                                 <div style={{ marginTop: "0", flex: '0 0 15%', padding: '1% 0 1% 0', scale: '0.7', position: 'relative'}} className="col-12 md:col-6 flex align-items-end">
                                                                                                     <Button
                                                                                                         icon="pi pi-minus"
                                                                                                         className="p-button-danger"
                                                                                                         type='button'
                                                                                                         onClick={() => removeRepairman(index)}
                                                                                                         disabled={formDataServiceLog.ostaliMajstori.length === 0}
                                                                                                     />
                                                                                                 </div>
                                                                                             </div>
                                                                                             <Dropdown
                                                                                                 placeholder={t('servis.dodatniMajstor')}
                                                                                                 id={`ostaliMajstori-${index}`}
                                                                                                 name="ostaliMajstori"
                                                                                                 style={{width: '100%'}}
                                                                                                 required
                                                                                                 invalid={invalidControl(formDataServiceLog.ostaliMajstori)}
                                                                                                 value={majstor}
                                                                                                 options={employeeDB || []}
                                                                                                 onChange={(e) => handleChange({ target: { name: "ostaliMajstori", value: e.value } }, index)}
                                                                                             />
                                                                                         </div>
                                                                                     </div>
                                                                                 ))}
                                                                             </div>
                                                                 </div>
                                    <div className="col-12 md:col-6">
                                        <label htmlFor="datumPocetka">{t('servis.datumPocetkaServisa')}:</label>
                                        <Calendar style={{width:"100%"}} id="datumPocetka" required
                                                  invalid={invalidControl(formDataServiceLog.datumPocetka)} name="datumPocetka" value={formDataServiceLog.datumPocetka} showIcon dateFormat="dd.mm.yy" showTime hourFormat="24" mask="99.99.9999 99:99"
                                                  onChange={(e) => handleChange({ target: { name: 'datumPocetka', value: e.value } })} />
                                    </div>
                                                                             <div className="col-12 md:col-6">
                                                                                         <div style={{display:'flex', justifyContent: 'space-between'}}>
                                                                                             <h5 style={{ width: '85%', marginTop: '2%' }}>{t('servis.spisakRadova')}:</h5>
                                                                                             <div style={{ marginTop: "0", width: "15%", padding: '1% 0 1% 0', scale: '0.7' }}>
                                                                                                 <Button icon="pi pi-plus" type="button" onClick={addRepair} className="p-button-success" />
                                                                                             </div>
                                                                                         </div>
                                                                             <div className="additionalRepairman">
                                                                                 {formDataServiceLog.spisakRadova.map((rad, index) => (
                                                                                     <div key={index} className="red1 odgovornaLica">
                                                                                         <div className="col-12 md:col-6">
                                                                                             <div style={{display:'flex', justifyContent: 'space-between', width:'100%'}}>
                                                                                                 <div style={{ flex: '0 0 85%', marginTop: '2%', marginLeft: '2%' }}>
                                                                                                     <label >Intervencija {index + 1}:</label>
                                                                                                 </div>
                                                                                                 <div style={{ marginTop: "0", flex: '0 0 15%', padding: '1% 0 1% 0', scale: '0.7', position: 'relative'}} className="col-12 md:col-6 flex align-items-end">
                                                                                                     <Button
                                                                                                         icon="pi pi-minus"
                                                                                                         className="p-button-danger"
                                                                                                         type='button'
                                                                                                         onClick={() => removeRepair(index)}
                                                                                                         disabled={formDataServiceLog.spisakRadova.length === 0}
                                                                                                     />
                                                                                                 </div>
                                                                                             </div>
                                                                                             <InputText
                                                                                                 placeholder={t('servis.dodatniRad')}
                                                                                                 id={`spisakRadova-${index}`}
                                                                                                 name="spisakRadova"
                                                                                                 style={{width: '100%'}}
                                                                                                 required
                                                                                                 invalid={invalidControl(formDataServiceLog.spisakRadova)}
                                                                                                 value={rad}
                                                                                                 onChange={(e) => handleChange({ target: { name: "spisakRadova", value: e.target.value } }, index)}
                                                                                             />
                                                                                         </div>
                                                                                     </div>
                                                                                 ))}
                                                                             </div>
                                                                 </div>
                                    <div className="col-12 md:col-6">
                                        <label htmlFor="statusServisa">{t('servis.statusServisa')}:</label>
                                              <CustomDropdown
                                                      id="statusServisa"
                                                      name="statusServisa"
                                                      value={formDataServiceLog.statusServisa}
                                                      onChange={handleChange}
                                                      style={{width:"100%"}}
                                                      className=""
                                                      optionLabel="label"
                                                      options={statusServisaDB || []}
                                                      placeholder={t('servis.statusServisa')}
                                                      required
                                                      invalid={invalidControl(formDataServiceLog.statusServisa)}
                                                    />
                                    </div>
                                    <div className="col-12 md:col-6">
                                        <label htmlFor="datumZavrsetka">{t('servis.datumZavrsetkaServisa')}:</label>
                                        {porukaTimeRange && <p class="infoPoruka" style={{fontSize: "10px"}}>{porukaTimeRange}</p>}
                                        <Calendar style={{width:"100%"}} id="datumZavrsetka" name="datumZavrsetka" value={formDataServiceLog.datumZavrsetka} showIcon dateFormat="dd.mm.yy" showTime hourFormat="24" mask="99.99.9999 99:99"
                                                  onChange={(e) => handleChange({ target: { name: 'datumZavrsetka', value: e.value } })} />
                                    </div>
                                    <div className="col-12 md:col-6" style={{flex: '0 0 39%'}}>
                                        <label htmlFor="napomena">{t('nova.napomena')}:</label>
                                        <InputTextarea style={{width:"100%"}} variant="filled" name="napomena" value={formDataServiceLog.napomena} onChange={handleChange} rows={5} cols={30} />
                                    </div>
                                    <div className="col-12 md:col-6" style={{flex: '0 0 39%'}}>
                                        <label htmlFor="napomenaVozaca">{t('ture.napomenaVozaca')}:</label>
                                        <InputTextarea style={{width:"100%"}} variant="filled" name="napomenaVozaca" value={formDataServiceLog.napomenaVozaca} onChange={handleChange} rows={5} cols={30} />
                                    </div>
                                </div>
                            </Card>
                        </div>

        {/* ── DELOVI FORMA ── */}
        <form autoComplete="off" ref={formRefItems}>
          <div className="gridLicni" style={{marginBottom: '1%', marginLeft: '1%'}}>

            {/* Guma checkbox */}
            <div className="col-12 md:col-6" style={{display:'flex', alignItems:'center', gap:'0.5rem', flex:'0 0 fit-content', maxWidth:'fit-content'}}>
              <input
                type="checkbox"
                id="isGuma"
                checked={formDataServiceLogItems.isGuma}
                onChange={(e) => handleChangeItems({ target: { name: 'isGuma', value: e.target.checked } })}
                style={{width:'1rem', height:'1rem', cursor:'pointer'}}
              />
              <label htmlFor="isGuma" style={{marginBottom:0, cursor:'pointer'}}>{t('servis.guma')}</label>
            </div>

            {/* Magacin */}
            <div className="col-12 md:col-6">
              <label htmlFor="id_magacin">{t('nova.magacin')}:</label>
              <Dropdown
                style={{width:"100%"}}
                id="id_magacin"
                name="id_magacin"
                value={formDataServiceLogItems.id_magacin}
                options={
                  formDataServiceLogItems.isGuma
                    ? magacinDB.filter(m => gumeDB.some(g => g.id_magacin === m.value))
                    : magacinDB || []
                }
                required
                invalid={invalidControlItems(formDataServiceLogItems.id_magacin)}
                onChange={handleChangeItems}
                placeholder={t('nova.phMagacin')}
              />
            </div>

            {/* Artikal */}
            <div className="col-12 md:col-6">
              <label htmlFor="id_deo">{t('nova.artikal')}:</label>
              <CustomDropdown
                style={{width:"100%"}}
                id="id_deo"
                name="id_deo"
                value={formDataServiceLogItems.id_deo}
                onChange={handleChangeItems}
                optionLabel="label"
                options={
                  formDataServiceLogItems.isGuma
                    ? (() => {
                        const seen = new Set();
                        return gumeDB
                          .filter(g => g.id_magacin === formDataServiceLogItems.id_magacin)
                          .filter(g => { if (seen.has(g.id_artikal)) return false; seen.add(g.id_artikal); return true; })
                          .map(g => ({ value: g.id_artikal, label: g.naziv_artikla }));
                      })()
                    : (partDB ?? []).filter(pt => {
                        const magacinId = formDataServiceLogItems.id_magacin;
                        const magacinIds = Array.isArray(magacinId) ? magacinId : [magacinId];
                        return magacinIds.includes(pt.id_magacin);
                      })
                }
                placeholder={t('nova.phArtikal')}
                required={formDataServiceLogItems.id_magacin != null}
                invalid={formDataServiceLogItems.id_magacin !== null ? invalidControlItems(formDataServiceLogItems.id_deo) : null}
              />
            </div>

            {/* Serijski broj — samo za gume */}
            {formDataServiceLogItems.isGuma && (
              <div className="col-12 md:col-6">
                <label htmlFor="ser_broj">{t('servis.serijskiDot')}:</label>
                <CustomDropdown
                  style={{width:"100%"}}
                  id="ser_broj"
                  name="ser_broj"
                  value={formDataServiceLogItems.ser_broj}
                  onChange={handleChangeItems}
                  optionLabel="label"
                  options={gumeDB.filter(g =>
                    g.id_magacin === formDataServiceLogItems.id_magacin &&
                    g.id_artikal === formDataServiceLogItems.id_deo
                  )}
                  placeholder={t('magacin.serijskiBroj')}
                  required={formDataServiceLogItems.isGuma && formDataServiceLogItems.id_deo != null}
                  invalid={formDataServiceLogItems.id_deo != null ? invalidControlItems(formDataServiceLogItems.ser_broj) : null}
                />
              </div>
            )}

            {/* Količina */}
            <div className="col-12 md:col-6">
              <label htmlFor="kolicina">{t('nova.kolicina')}:</label>
              {porukaKolicina && <p className="infoPoruka" style={{fontSize: "10px"}}>{porukaKolicina}</p>}
              <div className="fakture-stavke-radnje">
                <InputNumber
                  style={{flex: 1, minWidth: 0}}
                  id="kolicina"
                  name="kolicina"
                  value={formDataServiceLogItems.kolicina}
                  required={formDataServiceLogItems.id_deo != null}
                  invalid={formDataServiceLogItems.id_deo != null ? invalidControlItems(formDataServiceLogItems.kolicina) : null}
                  onValueChange={handleChangeItems}
                  placeholder={t('nova.kolicina')}
                />
                <button className="btn btn-secondary" type="submit" onClick={handleInputItems} style={{whiteSpace: 'nowrap', flexShrink: 0}}>
                  +STAVKA
                </button>
              </div>
            </div>

          </div>
        </form>

        <div className="gridPutniNalog">
          <div className="second_popup_r">

            {/* ── DELOVI ── */}
            <div className="radni_nalog_stavka" style={{maxHeight: '20vh'}}>
              {formDataServiceLogItemsData.length > 0 ? (
                <table style={{width: '50%'}}>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>{t('nova.magacin')}</th>
                      <th>Deo</th>
                      <th>Ser. br.</th>
                      <th>{t('nova.kolicina')}</th>
                      <th>{t('common.delete')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formDataServiceLogItemsData.map((item, i) => {
                      const magacin = magacinDB.find(p => p.value === item.id_magacin);
                      const deo = item.isGuma
                        ? gumeDB.find(g => Number(g.id_artikal) === Number(item.id_deo))
                        : partDB.find(p => p.value === item.id_deo);
                      return (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{magacin ? magacin.label : 'Nepoznat magacin'}</td>
                          <td>{deo ? (item.isGuma ? deo.naziv_artikla : deo.label) : (item.naziv_artikla || 'Nepoznat deo')}</td>
                          <td>{item.ser_broj || '-'}</td>
                          <td>{item.kolicina}</td>
                          <td>
                            <button type="button" onClick={() => handleDeleteItem(i)} style={{cursor: 'pointer', background: 'none', border: 'none'}}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                                <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                              </svg>
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              ) : (
                "Niste uneli ni jednu stavku za delove!"
              )}
            </div>


          </div>
        </div>

        <div className="formUnosZap buttonUnosZap" style={{borderTop: '1px solid rgb(224, 221, 221)', paddingTop:'1%'}}>
          <button type="submit" onClick={handleFormSubmit} className="btn btn-success">
            {izabran && popuni ? 'SAČUVAJ' : 'UNOS'}
          </button>
        </div>
      </form>
      </div>

    </>
  )
};

export default UnosRadnihPop;
